import { useMemo } from "react";
import { BrandTheme, StyleConfig, ThemeConfig } from "../types/SurveyTypes";
import { ThemeManager } from "../components/ThemeManger";

export const useThemeManager = (
  brandTheme: BrandTheme = {},
  styleConfig: StyleConfig = {},
  themeConfig: ThemeConfig = {},
  questThemeData: any = {}
) => {
  return useMemo(
    () =>
      new ThemeManager(brandTheme, styleConfig, themeConfig, questThemeData),
    [brandTheme, styleConfig, themeConfig, questThemeData]
  );
};
